import { TriggerCreate } from "@dots-projects/types";
import { v4 as uuidv4 } from "uuid";
import gif from "./collectEmail.gif";

export const collectEmail = (
  workspace: string
): {
  trigger: TriggerCreate;
  gif: any;
  title: string;
  description: string;
} => {
  return {
    title: "Collect Email",
    description:
      "<p>Closer communication with your community members? In this template Dots will add a button that allows users to write their email, then you will have access to them through the bot tracking view.</p>",
    gif,
    trigger: {
      name: "Collect Email",
      type: "button_click",
      platform: "discord",
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
      isDraft: true,
      configs: {
        messages: [
          {
            id: uuidv4(),
            buttonIds: [uuidv4()],
          },
        ],
        skipDefer: true,
        responseOnError: "Something went wrong, please try again!",
        responseOnComplete: "Success! Please continue.",
        $$editorButtonClickContent: {
          message:
            "Please enter your email address to receive promotions and updates",
          buttonText: "Enter email",
          buttonEmoji: "📧",
          channelId: "1075908920138289285",
          htmlMessage:
            "<p>Please enter your email address to receive promotions and updates</p>",
        },
      },
      steps: [
        {
          id: "open_modal-0-1HYQjg",
          type: "open_modal",
          configs: {
            title: "Collect email",
            fields: [
              {
                id: "field",
                type: "open_modal",
                label: "Email",
                style: "short",
              },
            ],
          },
          isEntry: true,
          isGoal: false,
          name: "Show a modal",
          transitions: [
            {
              targetStepId: "send_message-0-5pU62R",
              when: {
                userResponse: {
                  type: "modal-submit",
                  userId: "{{user.id}}",
                  modalId: "{{open_modal-0-1HYQjg.modalId}}",
                },
              },
            },
          ],
        },
        {
          id: "send_message-0-5pU62R",
          type: "send_message",
          configs: {
            message:
              "Great, we will keep you posted with our latest updates by email!",
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            removeUrlEmbeds: false,
            $$editorHtmlMessage:
              "<p>Great, we will keep you posted with our latest updates by email!</p>",
            sendBrandingIfNotPremium: true,
          },
          isEntry: false,
          isGoal: false,
          name: "Send a message",
          transitions: [],
        },
      ],
    },
  };
};
